"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = __importDefault(require("src/providers/theme"));
var responsive_1 = __importDefault(require("src/providers/responsive"));
var UIKitProvider = function (_a) {
    var theme = _a.theme, dark = _a.dark, breakpoint = _a.breakpoint, children = _a.children;
    return (react_1.default.createElement(theme_1.default, { theme: theme, dark: dark, breakpoint: breakpoint },
        react_1.default.createElement(responsive_1.default, { breakpoint: breakpoint }, children)));
};
exports.default = UIKitProvider;
